
function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    document.documentElement.classList.add('showing-menu');
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    document.documentElement.classList.remove('showing-menu');
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');
    document.documentElement.classList.add('showing-menu');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    document.documentElement.classList.remove('showing-menu');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length) linkElements.forEach(button => {
          button.removeAttribute('tabindex');
        });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length) linkElements.forEach(button => {
          button.setAttribute('tabindex', '-1');
        });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach(mediaGallery => mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true));

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);




/*!
 * pure-swipe.js - v1.0.5
 * Pure JavaScript swipe events
 * https://github.com/john-doherty/pure-swipe
 * @inspiration https://stackoverflow.com/questions/16348031/disable-scrolling-when-touch-moving-certain-element
 * @author John Doherty <www.johndoherty.info>
 * @license MIT
 */
!function(t,e){"use strict";"initCustomEvent"in e.createEvent("CustomEvent")&&(t.CustomEvent=function(t,n){n=n||{bubbles:!1,cancelable:!1,detail:void 0};var u=e.createEvent("CustomEvent");return u.initCustomEvent(t,n.bubbles,n.cancelable,n.detail),u},t.CustomEvent.prototype=t.Event.prototype),e.addEventListener("touchstart",function(t){if("true"===t.target.getAttribute("data-swipe-ignore"))return;l=t.target,i=Date.now(),n=t.touches[0].clientX,u=t.touches[0].clientY,a=0,o=0},!1),e.addEventListener("touchmove",function(t){if(!n||!u)return;var e=t.touches[0].clientX,i=t.touches[0].clientY;a=n-e,o=u-i},!1),e.addEventListener("touchend",function(t){if(l!==t.target)return;var e=parseInt(l.getAttribute("data-swipe-threshold")||"20",10),s=parseInt(l.getAttribute("data-swipe-timeout")||"500",10),r=Date.now()-i,c="";Math.abs(a)>Math.abs(o)?Math.abs(a)>e&&r<s&&(c=a>0?"swiped-left":"swiped-right"):Math.abs(o)>e&&r<s&&(c=o>0?"swiped-up":"swiped-down");""!==c&&(l.dispatchEvent(new CustomEvent(c,{bubbles:!0,cancelable:!0})));n=null,u=null,i=null},!1);var n=null,u=null,a=null,o=null,i=null,l=null}(this,document);


function scrolledCheck() {
  if (!deviceIsMobile.matches) {
    //// Toggle browser-scrolled class used on many areas
    if ($(window).scrollTop() > 2) {
      $("body").addClass("browser-scrolled");
    } else {
      $("body").removeClass("browser-scrolled");
    }
  } else {
  //// Show/hide buy now button on mobile PDP

    if ($(window).scrollTop() > 30) {
      $("body").addClass("buynow-button--show");
    } else {
      $("body").removeClass("buynow-button--show");
    }

    if ($(window).scrollTop() > 35) {
      $("body").addClass("browser-scrolled-mobile");
    } else {
      $("body").removeClass("browser-scrolled-mobile");
    }
  }
}

function prioritizeCartTabIndexGlobal($kreweClick) {
  $('.mini-cart button:first').focus();
  $('.mini-cart, .mini-cart button, .mini-cart a, .mini-cart input').each(function(){
    $(this).attr('tabindex', '1');
  });

}

function decreaseCartTabIndex() {

  $('.mini-cart, .mini-cart button, .mini-cart a, .mini-cart input').each(function(){
    $(this).attr('tabindex', '-1');
  });

}

function miniAccountDisableBackgroundTabIndexes() {

}

function miniAccountRestoreBackgroundTabIndexes() {

}

function miniCartDisableBackgroundTabIndexes() {
 
}

function miniCartRestoreBackgroundTabIndexes() {

}



function keyboardNavgationFocusFirstElement($this) {
  // Check if first focusable element is a button or link
  if ($this.find('button:first').length) {
    $this.find('button:first').focus();
  } else if ($this.find('a:first').length) {
    $this.find('a:first').focus();
  }
};

$(document).on('click', '.skip-to-footer', function(){

  let $this = $(this);
  let clickedElementID = $this.attr('href');
  let $element = $(clickedElementID);

  keyboardNavgationFocusFirstElement($element);

});


 
  if (!deviceIsMobile.matches) {
    $(window).on("scroll", function () { 
        scrolledCheck(); 
    });
  } else {
    if ($('body').hasClass('template-product')) {
      $(window).on("scroll", function () {  
          scrolledCheck();
      });
    }
  }


if (!deviceIsMobile.matches) {
  $(document).on('click', '.header__icon--account:not(.customer-logged-in)', function(e){
    e.preventDefault();
    $('body').addClass('mini-account-open');
    $('.mini-account, .mini-account-overlay').attr('aria-hidden', 'false');
        
    $('.customer-login-form input, .customer-login-form button, .mini-account-footer, .mini-account-close').each(function(){
      $(this).attr('tabindex', '1');
    });
    $('.mini-account-close').focus();
    miniAccountDisableBackgroundTabIndexes();
  });
}

$(document).on("click", ".header__icon--cart", function (e) {
  e.preventDefault();
  $("body").addClass("mini-cart-open");
  prioritizeCartTabIndexGlobal();
  miniCartDisableBackgroundTabIndexes();
});


$(document).on('click', '.mini-account-close', function(e){
  e.preventDefault();
  $('body').removeClass('mini-account-open');
  $('.mini-account, .mini-account-overlay').attr('aria-hidden', 'true');
  $('.mini-account input, .mini-account button, .mini-account a').each(function(){
    $(this).attr('tabindex', '-1');

  });
  $('.header__icon--account').focus();
  miniAccountRestoreBackgroundTabIndexes();
});

$(document).on('click', '.icon-hamburger', function(){
  $('body').addClass('mobile-nav-open');
});

$(document).on('click', '.header__icon--menu .icon-close', function(){
  $('body').removeClass('mobile-nav-open');
  $('.show-nav-countries').removeClass('show-nav-countries close-countries')
});


var productPlusHover;

$(document).on('mouseenter', '.family-plus', function() {
  var $this = $(this);
  var $mainCard = $this.parents('.grid__item');
  productPlusHover = setTimeout(function() {
    $mainCard.addClass('show-large-family');
  }, 200);
});

$(document).on('mouseleave', '.family-plus', function() {
  clearTimeout(productPlusHover);
});

$(document).on('click', '.show-large-family .family-plus', function() {
  var $this = $(this);
  var $mainCard = $this.parents('.grid__item');
  $mainCard.removeClass('show-large-family');
});


$(document).on('click','.js-reset-password-fadein',function(){$('.recover-password-form').fadeIn(0);$('.customer-login-form').fadeOut(0)});$(document).on('click','.js-rest-password-fadeout',function(){$('.recover-password-form').fadeOut(0);$('.customer-login-form').fadeIn(0)});

if (deviceIsMobile.matches) {


  $('footer ul.footer-block__details-content').each(function() {
    $(this).attr('aria-hidden', 'true');
  });


  $(document).on("click", "footer h3", function () {
      var $this = $(this);
      if ($this.hasClass('footer-nav-list-open')) {
        $this.addClass("stay-bolded");
        $this.removeClass("footer-nav-list-open");
        $this.parent().removeClass("footer-nav-wrapper-opened");
        setTimeout(function () {
          $this.removeClass("stay-bolded");
        }, 750);

        $this.parent().find('ul').attr('aria-hidden', 'true');
      } else {
    
        $('.footer-nav-list-open').addClass("stay-bolded");
    
        setTimeout(function(){
          $('.stay-bolded:not(.footer-nav-list-open)').removeClass('stay-bolded')
    
        },700);
    
       
    
        $("footer h3").removeClass("footer-nav-list-open");
        $('.footer-nav-wrapper').removeClass("footer-nav-wrapper-opened");
        $(".mobile-nav-trigger-link").attr("aria-hidden", true);

        $('.footer-nav-wrapper').find('ul').attr('aria-hidden', 'true');
    
        $this.addClass("footer-nav-list-open");
        $this.parent().addClass("footer-nav-wrapper-opened");
        $this.parent().find('ul').attr('aria-hidden', 'false');
    
      }




  });
 
}

if ($('.pdp-family-products-swatch-bar').hasClass('large-product-swatch-bar')) {
  //$('.plus-minus-swatch').insertAfter('.pdp-family-products-swatch-bar .pdp-family-swatch-product:nth-of-type(7)');
  $('.pdp-family-products-swatch-bar .pdp-family-swatch-product:nth-of-type(8)').css('opacity', 1);
}




document.addEventListener('swiped-down', function(e) {
   

    var pulled_down_class = $(e.target).attr('class');
    //console.logpulled_down_class); // element that was swiped

    if (pulled_down_class === 'countries-message' &&  $(e.target).scrollTop() == 0) {
      //console.log'top of countries swiped down');
      $('.show-nav-countries .arrow-down-link').click();
    }


});

// Check if the device is a mobile device
function isMobileIndex() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}

// Check if the device width is less than 990 pixels
function isSmallScreen() {
  return window.innerWidth < 990;
}

// Add or remove the .body-index-scrolled class on scroll
function handleScrollIndexLogo() {
  var body = document.getElementsByTagName('body')[0];
  if (body.classList.contains('template-index') && isMobileIndex() && isSmallScreen()) {
    if (window.pageYOffset > 20) {
      body.classList.add('body-index-scrolled');
    } else {
      body.classList.remove('body-index-scrolled');
    }
  }
}

// Add event listener to window scroll event
window.addEventListener('scroll', handleScrollIndexLogo);

document.addEventListener('keyup', function(event) {
  if (event.key === 'Escape') {
    if ($('header .localization-form__select').hasClass('view-currencies')) {
      $('header .localization-form__select').click();
      $('header #CountryList .disclosure__link').each(function(){
        var $this = $(this);
        $this.attr('tabindex', '-1');
      })
    }

    if ($('body').hasClass('mini-cart-open')) {
      $('body').removeClass('mini-cart-open');
      $('.mini-cart').attr('tabindex', '-1');

      miniCartRestoreBackgroundTabIndexes();
    }

    if ($('body').hasClass('mini-account-open')) {
      $('body').removeClass('mini-account-open');
      miniAccountRestoreBackgroundTabIndexes();
    }

    if ($('body').hasClass('search-bar-open')) {
      $('body').removeClass('search-bar-open');

      $('.search-bar a, .search-bar button').attr('tabindex', '-1');
      $('.header__search_btn').focus();
    }

    if ($('.desktop-navbar-nav-dropdown.open').length) {
      $(".menu-bg").removeClass("menu-visible");
      $('.desktop-navbar-nav-dropdown').removeClass('open');
      $('.desktop-navbar-nav-dropdown-menu a').attr('tabindex', '-1');
      $('.dropdown-menu').attr('aria-hidden', 'true');
      $('.desktop-navbar-nav-dropdown-toggle').attr('aria-expanded', 'false');
    }
  }
});

// Helper function to get a cookie by name
function getCookie(name) {
  var value = "; " + document.cookie;
  var parts = value.split("; " + name + "=");
  if (parts.length === 2) return parts.pop().split(";").shift();
}

// Helper function to set a cookie
function setCookie(name, value, hours) {
  var expires = "";
  if (hours) {
    var date = new Date();
    date.setTime(date.getTime() + (hours * 60 * 60 * 1000));
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

if (!$(".gf-product").is(":empty") && !getCookie("sawGoinFastPopup_9") && window.theme.templateName != "product") {
  setTimeout(function () {
    $("body").addClass("show-going-fast-popup");
  }, 2000);
}

$(document).on("click", ".close-going-fast-popup", function () {
  var inHalfDay = 0.5;
  $('body').removeClass('show-going-fast-popup');
  setCookie("sawGoinFastPopup_9", "true", inHalfDay);
});






$(document).on('click', '.custom-popup-close', function() {
  $('.header-popup').fadeOut(300);
});

window.addEventListener('pageshow', function(event) {
  // Select the specific details element by its ID
  var menuDrawer = document.querySelector('#Details-menu-drawer-container');

  // Check if the menu drawer exists to avoid errors
  if (menuDrawer) {
      // Remove the 'open' attribute to close the menu
      menuDrawer.removeAttribute('open');
      $('#Details-menu-drawer-container summary').attr('aria-expanded', 'false').removeClass('menu-opening');
      $('#Details-menu-drawer-container').removeClass('menu-opening');
      $('.section-header').removeClass('menu-open');
      $('body').removeClass('overflow-hidden-tablet');
      $('.mobile-navbar-nav-pillar').removeClass('bold--text')
  }
});

document.getElementById('customer_login').addEventListener('keypress', function(e) {
  if (e.key === 'Enter') {
      e.preventDefault(); // Prevent the default form submit behavior
      // Explicitly submit the form, or define other actions
      this.submit();
  }
});

$(document).ready(function(){

$('.footer-block__details-content a').click(function(event) {
  var linkHref = $(this).attr('href');
  var linkText = $(this).text();
  if (typeof mixpanel !== 'undefined') {
    mixpanel.track("Footer Clicked",{"Link URL": linkHref,"Name": linkText})
  }
});

$('.header__icon--account').click(function() {
  if (typeof mixpanel !== 'undefined') {
    mixpanel.track("Login Started (Page Viewed)",{'page': 'Login-Page'});
  }

});

$('.mini-account-register-trigger').click(function() {
  if (typeof mixpanel !== 'undefined') {
    mixpanel.track("Signup Started (Page Viewed)",{'page': 'Signup-Page'});
  }
});

//Banner Clicked
  if ($('body').hasClass('template-index')) {
    // Click event handler for banner
    $('.hp-editorial').click(function(event) {
        //console.log("Page URL: " + window.location.href);
        var bannerLabel = $(this).find('.hp-editorial-image').attr('data-gtm-label');
        var bannerLinkURL = $(this).find('.hp-editorial-image').attr('data-gtm-action');
      if (typeof mixpanel !== 'undefined') {
        mixpanel.track("Banner Clicked",{"PageURL":window.location.href,"Banner Label": bannerLabel,"Banner Link URL":bannerLinkURL})
      }

    });


    //Content Clicked
    $(document).on('click', 'a.editorial-block-link, .hp-editorial-cta', function(event) {
      // Check if the clicked element contains an img element
      if ($(this).find('img').length > 0) {
          // Get the clicked element
          var clickedElement = this;

          // Get the name of the clicked element
          var elementName = $(clickedElement).attr('name');

          // If name attribute is not defined, use the element's tag name
          if (!elementName) {
              elementName = clickedElement.tagName.toLowerCase();
          }

          // Get the value of the <span> element within the clicked element
          var spanValue = $(clickedElement).find('span').text();

          // Get the destination URL if the clicked element is a link
          var destinationURL = '';
          if ($(clickedElement).is('a')) {
              destinationURL = $(clickedElement).attr('href');
          }
          if (typeof mixpanel !== 'undefined') {
            // Track the event only if an image is present within the clicked element
            mixpanel.track("Content Clicked", {
                "PageURL": window.location.href,
                "Destination URL": destinationURL,
                "name": elementName
            });
          }
      }
    });


    $(document).on('click', '.card__media picture, .card__media img', function(event) {
      // Check if the clicked element is an img or picture element
      if ($(this).is('img') || $(this).is('picture')) {
          // Get the clicked element
          var clickedElement = this;

          // Get the name of the clicked element
          var elementName = $(clickedElement).attr('alt');

          // If name attribute is not defined, use the element's tag name
          if (!elementName) {
              elementName = clickedElement.tagName.toLowerCase();
          }

          // Get the destination URL if the clicked element is a link
          var destinationURL = $(clickedElement).closest('.plp-carousel-wrapper').find('.media-link').attr('href');
          if (typeof mixpanel !== 'undefined') {
            // Track the event only if an image is clicked
            mixpanel.track("Content Clicked", {
                "PageURL": window.location.href,
                "Destination URL": destinationURL,
                "name": elementName
            });
          }
      }
    });

    const editorialLinks = document.querySelectorAll('.editorial-block-link');

    // Check each link
    editorialLinks.forEach(link => {
        // Get the desktop URL from data attribute
        const desktopUrl = link.dataset.desktopBlockUrl;
        
        // If we're not on mobile AND there's a valid desktop URL
        if (!deviceIsMobile.matches && desktopUrl && desktopUrl !== 'false') {
            // Update the href
            link.href = desktopUrl;
        }
    });
  }

  //Subscription Registered Footer
  $(document).on('click', 'button.subscribe-form-subscribe', function(event) {
    if (typeof mixpanel !== 'undefined') {
      mixpanel.track("Subscription Registered",{"Source": "Footer"})
    }
  });
});

// Function to push click events to GTM dataLayer
function gtmPushWebsiteClickEvent(section, action, label = '') {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
      event: "data_layer_website_click",
      "website_clicks_section": section,
      "website_clicks_action": action,
      "website_clicks_label": label
  });
}

// Helper function to sanitize the label
function sanitizeLabel(label) {
  if (typeof label !== 'string') return '';
  return label.trim().replace(/\s+/g, ' ');
}

// Click event handler
function gtmHandleClick(event) {
  // Find closest parent (including self) with data-gtm-dynamic-click
  const gtmElement = event.target.closest('[data-gtm-dynamic-click="true"]');
  
  if (!gtmElement) return;

  const section = gtmElement.getAttribute('data-gtm-category');
  const action = gtmElement.getAttribute('data-gtm-action');
  let label = gtmElement.getAttribute('data-gtm-label') || '';

  label = sanitizeLabel(label);

  if (section && action) {
      gtmPushWebsiteClickEvent(section, action, label);
  }
}

// Main tracking setup function that can be called anytime
function initializeGTMTracking(parentElement = document) {
  const trackableElements = parentElement.querySelectorAll('[data-gtm-dynamic-click="true"]');
  trackableElements.forEach(element => {
      // Avoid adding duplicate listeners
      if (!element.hasAttribute('data-gtm-initialized')) {
          element.addEventListener('click', gtmHandleClick);
          element.setAttribute('data-gtm-initialized', 'true');
      }
  });
}

// Example usage for dynamic content:
// After adding new content to the page:
// initializeGTMTracking(newlyAddedContainer);
// Or to reinitialize everything:
// initializeGTMTracking();

// Example usage for dynamic content:
// After adding new content to the page:
// initializeGTMTracking(newlyAddedContainer);
// Or to reinitialize everything:
// initializeGTMTracking();

document.addEventListener('DOMContentLoaded', (event) => {
  if (document.body.classList.contains('template-index') && deviceIsMobile.matches) {
    let lastScroll = window.scrollY;
    const topBarOffset = 35; // Height of the fixed top bar

    const debounceScroll = (func, wait, immediate) => {
      let timeout;
      return function() {
        const context = this, args = arguments;
        const later = function() {
          timeout = null;
          if (!immediate) func.apply(context, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (immediate && !timeout) func.apply(context, args);
      };
    };

    const setCSSVariables = () => {
      const rows = document.querySelectorAll('.nav-color-update');
      const viewportHeight = window.innerHeight;
      const currentScroll = window.scrollY;
      const isScrollingDown = currentScroll > lastScroll;

      rows.forEach(row => {
        const rect = row.getBoundingClientRect();
        let isActive = false;

        if (isScrollingDown && rect.top <= topBarOffset && rect.bottom > topBarOffset) {
          // When scrolling down, activate if the top of the section is just at the bottom of the top bar
          isActive = true;
        } else if (!isScrollingDown && rect.bottom >= topBarOffset && rect.top < topBarOffset) {
          // When scrolling up, activate if the bottom of the section is just at the top of the top bar
          isActive = true;
        }

        if (isActive) {
          const navbarMenuColor = row.dataset.navbarMenuColor;
          const navbarLogoColor = row.dataset.navbarLogoColor;
          const navbarIconsColor = row.dataset.navbarIconsColor;

          document.documentElement.style.setProperty('--navbar-menu-color', navbarMenuColor);
          document.documentElement.style.setProperty('--navbar-logo-color', navbarLogoColor);
          document.documentElement.style.setProperty('--navbar-icons-color', navbarIconsColor);
        }
      });

      lastScroll = currentScroll;
    };

    // Debounce scroll event for performance
    window.addEventListener('scroll', debounceScroll(setCSSVariables, 10));   
  }

  // Commenting out while debugging Action coming into GA4 blank
  initializeGTMTracking();

});

function throttleScrollCheck(fn, wait) {
  let time = Date.now();
  return function() {
    if ((time + wait - Date.now()) < 0) {
      fn();
      time = Date.now();
    }
  };
}

let stickyElementStyle = null;
let stickyElementTop = 0;

function determineStickyState() {
  const element = document.querySelector('#shopify-section-header');
  
  if (!stickyElementStyle) {
    stickyElementStyle = window.getComputedStyle(element);
    stickyElementTop = parseInt(stickyElementStyle.top, 10);
  }

  const currentTop = element.getBoundingClientRect().top;

  element.classList.toggle('header-sticky', currentTop <= stickyElementTop);
}

function checkStickyStateForMobile() {
  if (window.innerWidth < 991) {
    determineStickyState();
    window.addEventListener('scroll', throttleScrollCheck(determineStickyState, 100));
  } else {
    // Clean up: Remove the scroll event listener and reset styles if needed.
    window.removeEventListener('scroll', throttleScrollCheck(determineStickyState, 100));
    const element = document.querySelector('#shopify-section-header');
    if (element) {
      element.classList.remove('header-sticky');
    }
    stickyElementStyle = null;
    stickyElementTop = 0;
  }
}

// Initial check to set the sticky state when the page loads.
document.addEventListener('DOMContentLoaded', checkStickyStateForMobile);





